<app-page-bar></app-page-bar>

<app-page>

</app-page>

